import { useT } from '@repo/ui/hooks'
import { cn } from '@repo/ui/utils'
import { ReactNode } from 'react'

export function TaskList<T>({
  tasks,
  transkey,
  variant = 'default',
  taskChildSlot,
}: {
  tasks: T[]
  transkey: string
  variant?: 'default' | 'highlight'
  taskChildSlot: (task: T) => ReactNode
}) {
  const { tc } = useT()
  if (tasks.length === 0) return null
  return (
    <Section variant={variant} title={tc(transkey, { cfl: true })}>
      {tasks.map((task) => taskChildSlot(task))}
    </Section>
  )
}

const variantClasses = {
  default: 'text-primary-400',
  highlight: 'text-primary-600 font-medium',
}
export function Section({
  className,
  title,
  children,
  variant = 'default',
}: {
  className?: string
  title: string
  children?: ReactNode
  variant?: 'default' | 'highlight'
}) {
  const line = <div className="bg-primary-100 h-px flex-1" />
  return (
    <div className={cn('flex flex-col gap-2 pt-2', className)}>
      <div className="flex items-center justify-center gap-4 px-2">
        {line}
        <div className={cn('text-sm', variantClasses[variant])}>{title}</div>
        {line}
      </div>
      {children}
    </div>
  )
}
